// extracted by mini-css-extract-plugin
export default {"img":"_8yFgy","content":"loOZO","title":"M_471","link":"gB5dE"};